import React, { useState } from "react";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import "./EditProfilePopup.css";

const EditProfilePopup = ({ user, onClose }) => {
  const [name, setName] = useState(user.name || "");
  const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber || "");
  const [loading, setLoading] = useState(false);

  const companyCode = initialAuthState.companyCode;
  const unitCode = initialAuthState.unitCode;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = new FormData();
    payload.append("companyCode", companyCode);
    payload.append("unitCode", unitCode);
    payload.append("name", name);
    payload.append("phoneNumber", phoneNumber);

    try {
      const response = await ApiService.post(
        "/client/handleWebClientDetails",
        payload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status) {
        alert("Client updated successfully!");
        onClose(); // close the popup
      } else {
        alert("Failed to update. Please try again.");
      }
    } catch (error) {
      console.error("Error updating client details:", error);
      alert("Failed to update. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="editProfilePopup__container">
      <h3>Edit Profile</h3>
      <form onSubmit={handleSubmit}>
        <div className="editProfilePopup__formGroup">
          <label>Name</label>
          <input
            type="text"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="editProfilePopup__formGroup">
          <label>Phone Number</label>
          <input
            type="text"
            value={phoneNumber}
            required
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
        </div>
        <div className="editProfilePopup__buttonGroup">
          <button type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
          <button type="button" onClick={onClose} className="cancelBtn">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProfilePopup;
